var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIconBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.391633 21.701C-0.122949 22.2157 -0.138084 23.0936 0.391633 23.6083C0.92135 24.123 1.79917 24.123 2.31375 23.6083L12 13.9205L21.6863 23.6083C22.2008 24.123 23.0938 24.1381 23.6084 23.6083C24.123 23.0785 24.123 22.2157 23.6084 21.701L13.9221 11.9981L23.6084 2.31033C24.123 1.79566 24.1381 0.91771 23.6084 0.403047C23.0787 -0.126754 22.2008 -0.126754 21.6863 0.403047L12 10.0908L2.31375 0.403047C1.79917 -0.126754 0.906215 -0.141891 0.391633 0.403047C-0.122949 0.932847 -0.122949 1.79566 0.391633 2.31033L10.0779 11.9981L0.391633 21.701Z",
    fill: "#828282"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconBig);
export default __webpack_public_path__ + "static/media/close-icon-big.511a27690ee47b43ac79c46bd8984d6c.svg";
export { ForwardRef as ReactComponent };